import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TotalFromFareGroupsPipe } from './total-from-fare-groups.pipe';

@NgModule({
  declarations: [TotalFromFareGroupsPipe],
  imports: [CommonModule],
  exports: [TotalFromFareGroupsPipe],
})
export class TotalFromFareGroupsPipeModule {}
